import { render, staticRenderFns } from "./ErrorNotification.vue?vue&type=template&id=79ed4b8f&scoped=true"
import script from "./ErrorNotification.vue?vue&type=script&lang=ts"
export * from "./ErrorNotification.vue?vue&type=script&lang=ts"
import style0 from "./ErrorNotification.vue?vue&type=style&index=0&id=79ed4b8f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ed4b8f",
  null
  
)

export default component.exports